/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_ApertureInputs */

const en_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperture`)
};

const ar_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فتحة العدسة`)
};

const bn_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাপারচার`)
};

const de_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blende`)
};

const es_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apertura`)
};

const fr_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouverture`)
};

const pt_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abertura`)
};

const zh_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`光圈`)
};

const tr_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diyafram`)
};

const ru_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Диафрагма`)
};

const pl_image_inspector_aperture = /** @type {(inputs: Image_Inspector_ApertureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przysłona`)
};

/**
* | output |
* | --- |
* | "Aperture" |
*
* @param {Image_Inspector_ApertureInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_aperture = /** @type {((inputs?: Image_Inspector_ApertureInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_ApertureInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_aperture(inputs)
	if (locale === "bn") return bn_image_inspector_aperture(inputs)
	if (locale === "de") return de_image_inspector_aperture(inputs)
	if (locale === "es") return es_image_inspector_aperture(inputs)
	if (locale === "fr") return fr_image_inspector_aperture(inputs)
	if (locale === "pt") return pt_image_inspector_aperture(inputs)
	if (locale === "zh") return zh_image_inspector_aperture(inputs)
	if (locale === "tr") return tr_image_inspector_aperture(inputs)
	if (locale === "ru") return ru_image_inspector_aperture(inputs)
	if (locale === "pl") return pl_image_inspector_aperture(inputs)
	return en_image_inspector_aperture(inputs)
});